export { getActiveElement } from '@fluentui/dom-utilities';
